import { NumberInput, Stack, Text } from '@mantine/core';
import { SimpleSlider } from '@/app/components/shared/form/slider/SimpleSlider';
import { useFormContext } from '../../../contexts/formContext';
import { SettingTitle } from '../../../components/SettingTitle';
import { OnOffSetting } from '../../../components/OnOffSetting';

const path = 'assetSimplification.uvAndAtlasSettings';

export function UvAndAtlas() {
  const form = useFormContext();
  return (
    <Stack gap='lg'>
      <Stack gap='xs'>
        <SettingTitle
          title='UV Creation Method'
          description='Choose how the UV layout should be optimized. Hard-surface layouts tend to have less stretch, but more charts'
        />
        <SimpleSlider
          min={0}
          max={1}
          step={0.1}
          marks={[
            {
              label: 'Hard Surface',
              value: 0,
            },
            {
              label: 'Organic',
              value: 1,
            },
          ]}
          w={400}
          {...form.getInputProps(`${path}.uvStretchTolerance`)}
        />
      </Stack>
      <Stack>
        <Stack gap='xs'>
          <SettingTitle
            title='Atlas Factor'
            description='Atlas factor for determining how many atlases to bake per material. This can drastically improve texel resolution but comes at the cost of more textures and thus memory footprint.'
          />
          <NumberInput min={1} max={20} defaultValue={1} w={100} {...form.getInputProps(`${path}.atlasingFactor`)} />
        </Stack>
        <Stack gap='xs'>
          <SettingTitle
            title='Normals Shading Angle'
            description='Hard angle (degrees) used for normal generation (0 = everything flat, 180 = everything smooth)'
          />
          <NumberInput
            {...form.getInputProps(`assetSimplification.materialAndTextureBaking.normalsShading`)}
            defaultValue={60}
            min={0}
            max={180}
            w={100}
          />
        </Stack>
        <OnOffSetting
          onChanged={(option) =>
            form.setFieldValue('assetSimplification.materialAndTextureBaking.alphaBlendToMask', option)
          }
          initialOption={form.values.assetSimplification?.materialAndTextureBaking.alphaBlendToMask ?? false}
          title='Alpha Blend to Mask Conversion'
          description='Use alpha masking instead of blending when the alpha map has 40% or more black or white pixels'
        />
      </Stack>
    </Stack>
  );
}
